module.exports = __webpack_public_path__ + "img/c96de8913dc8d1dea3eb4cf1bcbc049c.png";